<div class="flex flex-col gap-4">
  <div class="flex flex-col gap-2">
    <span class="text-sm tracking-tight text-gray-800">Please select a period for the promo days</span>
  </div>
  <div class="flex">
    <IDatePicker
      [minDate]="data.minDate"
      [maxDate]="data.maxDate"
      [dateFormat]="dateFormat()"
      [withShortcuts]="false"
      [selectedDateRange]="dateRange()"
      (selectedDateRangeChange)="dateRange.set($event!)"
    />
  </div>
  <span class="text-sm text-gray-500"
    >Promo days will be active from <b>{{ startDate() }}</b> to <b>{{ endDate() }}</b></span
  >
  <div class="flex justify-end gap-2 border-t border-gray-200 pt-4">
    <button iButton variant="secondary" size="sm" (click)="modalRef.close()">
      {{ "Cancel" }}
    </button>
    <button
      iButton
      size="sm"
      [disabled]="isActivateButtonDisabled()"
      [iTooltip]="activateButtonTooltip()"
      (click)="activatePromoDays()"
    >
      {{ data.isEdit ? "Save" : "Activate Promo Days" }}
    </button>
  </div>
</div>
